import { message, Switch, TimePicker } from "antd";
import dayjs from "dayjs";
import React from "react";
import TimezoneSelect from "react-timezone-select";
import HButton from "../../../components/custom/input/button/Button";
import "../../assets/css/businessHours.css";
import HRadioGroup from "../../../components/custom/input/radio/HRadioGroup";
import { validateBusinessHourData, BusinessHourType, BusinessHourLabel } from "../../../utils/businessHourUtils";

const BusinessHour = ({
  id,
  data,
  number,
  businessHourData,
  setBusinessHourData,
  integId,
  isFromAdminSetting = false,
  businessHourSettingLabel,
}) => {
  const format = "HH:mm";

  const handleDayToggle = (day) => {
    setBusinessHourData((prevState) => ({
      ...prevState,
      businessDays: prevState?.businessDays?.map((item, index) =>
        index.toString() === day
          ? {
              ...item,
              isOpen: item?.isOpen ? 0 : 1,
            }
          : item,
      ),
    }));
  };

  const handleStartChange = (day, time) => {
    setBusinessHourData((prevState) => ({
      ...prevState,
      businessDays: prevState?.businessDays.map((item, index) =>
        index?.toString() === day
          ? {
              ...item,
              hourStartTime: time?.format("HH"),
              minuteStartTime: time?.format("mm"),
            }
          : { ...item },
      ),
    }));
  };

  const handleApplyToAll = () => {
    const mondayData = businessHourData?.businessDays[1];
    if (!mondayData) return;

    const { hourStartTime, minuteStartTime, hourEndTime, minuteEndTime } = mondayData;

    setBusinessHourData((prevState) => ({
      ...prevState,
      businessDays: prevState?.businessDays?.map((item) => ({
        ...item,
        hourStartTime,
        minuteStartTime,
        hourEndTime,
        minuteEndTime,
      })),
    }));
    message.success("Applied Monday timing to all days");
  };

  const handleEndChange = (day, time) => {
    setBusinessHourData((prevState) => ({
      ...prevState,
      businessDays: prevState?.businessDays?.map((item, index) =>
        index?.toString() === day
          ? {
              ...item,
              hourEndTime: time?.format("HH"),
              minuteEndTime: time?.format("mm"),
            }
          : item,
      ),
    }));
  };

  const handleSubmit = async () => {
    if (validateBusinessHourData(businessHourData)) {
      setBusinessHourData((prevState) => ({
        ...prevState,
      }));

      message.success("Applied successfully");
    }
  };

  const onCalenderHoursChange = (e) => {
    setBusinessHourData((prevState) => ({
      ...prevState,
      isCalendarHours: e.target.value === BusinessHourType.CALENDAR,
    }));
    if (e.target.value === BusinessHourType.CALENDAR && !isFromAdminSetting) {
      message.success(`Applied to ${BusinessHourLabel.CALENDAR}`);
    }
  };

  const dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const businessHourOption = [
    { value: BusinessHourType.CALENDAR, label: BusinessHourLabel.CALENDAR },
    {
      value: BusinessHourType.CUSTOM,
      label: BusinessHourLabel.CUSTOM,
    },
  ];

  return (
    <>
      <div className="h-100">
        <div className={`w-100 d-flex align-items-center ${businessHourData?.isCalendarHours ? "mb-2" : "mb-4"}`}>
          {isFromAdminSetting && businessHourSettingLabel && <div className="mb-0 w-100">{businessHourSettingLabel}</div>}
          <HRadioGroup
            className=""
            options={businessHourOption}
            radioGroupProps={{
              value: businessHourData?.isCalendarHours ? BusinessHourType.CALENDAR : BusinessHourType.CUSTOM,
              onChange: onCalenderHoursChange,
              className: `w-100 d-flex flex-row`,
            }}
          />
        </div>
        {!businessHourData?.isCalendarHours && (
          <div className={`d-flex flex-column align-items-start`} style={{ maxWidth: "345px", width: "100%" }}>
            <div style={{ width: "100%" }}>
              <label className="mb-2">Time Zone</label>
              <TimezoneSelect
                required={true}
                className="time-zone-select"
                value={businessHourData?.timeZone}
                onChange={(value) =>
                  setBusinessHourData((prevState) => ({
                    ...prevState,
                    timeZone: value.value,
                  }))
                }
              />
            </div>
            <div className="mt-4 w-100">
              {businessHourData?.businessDays &&
                ["1", "2", "3", "4", "5", "6", "0"].map((dayIndex) => {
                  const day = dayNames[dayIndex];
                  return (
                    <React.Fragment key={day}>
                      {dayIndex === "1" && businessHourData?.businessDays[dayIndex]?.isOpen === 1 && (
                        <div className="d-flex flex-row justify-content-end mb-2">
                          <span className="apply-to-all-days-btn" onClick={handleApplyToAll}>
                            Apply for all days
                          </span>
                        </div>
                      )}
                      <div className="d-flex align-items-center justify-content-between businessHour-container">
                        <div className="d-flex align-items-center">
                          <span style={{ width: 40 }}>{day}</span>
                          <Switch
                            className="addPhoneSwitch-chatView"
                            size="small"
                            checked={businessHourData?.businessDays[dayIndex]?.isOpen === 1}
                            onChange={() => handleDayToggle(dayIndex)}
                          />
                        </div>

                        <div className="d-flex align-items-center" style={{ gap: "10px" }}>
                          <TimePicker
                            className="bh-timer-picker"
                            popupClassName="timePickerPopupPanel"
                            allowClear={false}
                            value={
                              businessHourData?.businessDays[dayIndex]?.hourStartTime &&
                              businessHourData?.businessDays[dayIndex]?.minuteStartTime
                                ? dayjs(
                                    `${businessHourData?.businessDays[dayIndex]?.hourStartTime}:${businessHourData?.businessDays[dayIndex]?.minuteStartTime}`,
                                    format,
                                  )
                                : dayjs("09:00 ", format)
                            }
                            disabled={businessHourData?.businessDays[dayIndex]?.isOpen === 0}
                            format={format}
                            onChange={(time) => handleStartChange(dayIndex, time)}
                          />
                          <TimePicker
                            className="bh-timer-picker"
                            popupClassName="timePickerPopupPanel"
                            allowClear={false}
                            value={
                              businessHourData?.businessDays[dayIndex]?.hourEndTime && businessHourData?.businessDays[dayIndex]?.minuteEndTime
                                ? dayjs(
                                    `${businessHourData?.businessDays[dayIndex]?.hourEndTime || "12"}:${
                                      businessHourData?.businessDays[dayIndex]?.minuteEndTime || "00"
                                    }`,
                                    format,
                                  )
                                : dayjs("17:00", format)
                            }
                            disabled={businessHourData?.businessDays[dayIndex]?.isOpen === 0}
                            format={format}
                            onChange={(time) => handleEndChange(dayIndex, time)}
                          />
                        </div>
                      </div>
                    </React.Fragment>
                  );
                })}
            </div>
            {!isFromAdminSetting && (
              <HButton buttonClassName="mt-4" onClick={handleSubmit} size="s">
                Apply
              </HButton>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default BusinessHour;
